// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tabletMiddle":"(max-width: 768px)","root":"_3IEj4QlJkKP1","description_block":"s5pFeZUqgaF4","switch_block":"mqK6o-pig3bR"};